import { Button } from "@mantine/core";
import { Link, useNavigate } from "react-router-dom";
import { type IOrganiozation } from "src/pages/Management/Clients/Organizations/Organizations.types";
import { StyledTd, StyledTr } from "src/styled";

import { getStatus } from "../ManagementTable/ManagementTable.utils";

interface Props {
  row: IOrganiozation;
}

const OrganizationsRow = ({ row }: Props) => {
  const navigate = useNavigate();
  const to = `/management/clients/organizations/${row.clid}/yachts/${row.orgid}`;
  return (
    <StyledTr hover onClick={() => navigate(to)} style={{ cursor: "pointer" }}>
      <StyledTd>{row.orgname ?? row.clientname}</StyledTd>
      <StyledTd center>{row.yachts}</StyledTd>
      <StyledTd center>{getStatus(row.active)}</StyledTd>
      <StyledTd center style={{ width: 200 }}>
        <Button component={Link} to={to} w="90%" variant="outline">
          View
        </Button>
      </StyledTd>
    </StyledTr>
  );
};

export default OrganizationsRow;
